export default __webpack_public_path__ + "static/small-image-sportplus-3-d4cf39073546210a2b74ce775e80bd85.png";